// extracted by mini-css-extract-plugin
export default {"mediumHeroBackgroundImage":"mediumHero_mediumHeroBackgroundImage__4zICf","mediumHeroContentOverlay":"mediumHero_mediumHeroContentOverlay__CQaj4"};